import enLocale from 'element-ui/lib/locale/lang/en'
const en={
   enLocale,


   language:'English',
   noLanguage:'中文',

   jbts:'Report Complaints',
   ljrz:'Integrity Certification',
   lplj:'Gift Money',
   lyct:'Conflict of Interest',
   ljsj:'Honest Turn In',
   ljsy:'Integrity Sany',
   jbjlbz:'Reward Standard for Reporting',
   jbfscx:'Inquiry of Reporting Method',
   hxqd:'List of Red Line',

   dlsb:'Login failed! Please contact the Application administrator 田辉阳(tianhy16)',
   dl:'Integrity Sany Login',
   sy:'Home page',

   scz:'Uploading...',
   scsb:'Upload Failed',
   wj:'File',
   qsctpgswj:'Please upload image format file',
   jg:'Warning',
   scwj:'Please confirm whether to delete the file. It cannot be restored after deletion',
   shangchuanchenggong:'Upload successful',
   shanchuchenggong:'Delete successful',
	 csnbbm:'Internal Department',
	 csqymc:'Company name',
	 csqxzbm:'Please select a department',
	 csqtxqymc:'Please fill in the company name',
	 csxydm:'Credit Code',
	 cstxqymchdjsszddc:'After filling in the company name, click Search to automatically bring out',
	 sbljcns:'Integrity Commitment',
	 sbljcns1:'I acknowledge that the company has formulated a conflicts of interest management system, which clarifies the primary conditions and penalties of conflicts of interest.',
	//  sbljcns2:'I now declare that there are/may cause conflicts of interest when performing the duties assigned by the company:',
	 sbljcns2:'To ensure transparency in the performance of the duties assigned by the company, I hereby truthfully declare my personal situation as follows:',
	 sbwjs:'Accept',
	 tx:'Remind',
	 btc:'Do not fill',
	 tc:'Fill',
	 s:'Yes',
	 f:'No',
	 tctx:'It is detected that you have {type} data on {date}, do you need to fill in the current declaration data?',
	 tempSb:'declaration',
	 tempZc:'temporary storage',

	 sbItemTitle1:'Handling Enterprise',
	 sbItemQuest1:'1. I or in the name of others, alone or in joint venture / joint stock with others, or in the mode of contracting / leasing to run a business.',
	 sbItemTitle2:'Conflict of Interest between Relatives Handling Enterprises and Companies',
	 sbItemQuest2:'2. My immediate family members (including my spouse, children, myself and my spouse’s parents) run a business by themselves or in a joint venture/joint stock mode with others, and have business transactions with companies affiliated to Sany Group Co., Ltd., or business operations with Sany competitive relationship. (Except stock trading on the open market, funds, bonds and their derivatives investment, real estate investment).',
	 sbItemTitle3:'Employment and Part-time Job',
	 sbItemQuest3:'3. My immediate family members and I work in a supplier, customer, agent, competitor, or part-time job (Includes consulting, consultant or other similar capacity, excluding credentialing forms).',
	 sbItemTitle4:'Economic Exchanges',
	 sbItemQuest4:'4. My immediate family and I have borrowing, lending, and business transactions with individuals or units (excluding banking institutions) that do business within my authority. ',
	 sbItemTitle5:'Job convenience',
	 sbItemQuest5:'5. I ustilize company resources to help individuals and their relatives, classmates, friends, etc. to obtain benefits and corresponding opportunities. (For example, the business personnel introduce relatives and friends to work for suppliers under their jurisdiction, and company leaders arrange relatives and friends to work under their own hands, etc.)',
	 sbItemTitle6:'Kinship',
	 sbItemQuest6:'6. I have relatives working in the company before and after my employment [Includes: your spouse, parents, children (and their spouse and spouse’s parents), grandparents, grandchildren (and their spouse’s and spouse’s parents), step-parents, step-children (and their spouse’s and spouse’s parents), adoptive parents, adopted children (and their spouses and spouses’ parents), my siblings (and their spouses), uncles, aunts, cousins (and their spouses) nephews (and their spouses)] .',
	 sbItemTitle7:'Confidentiality and Non-compete Agreement',
	 sbItemQuest7:'7. The new employee in charge of the technical work has signed a technical “Confidentiality Agreement” with the previous company, and the agreement is within the validity period.',
	 sbItemTitle8:'Introducing Business',
	 sbItemQuest8:'8. Directors, personnel of key position personel and core position, or their related persons (including relatives, friends, classmates, and fellow villagers) introduce suppliers to conduct business with Sany (including infrastructure construction, procurement, outsourcing, and parts processing).',
	 sbItemTitle9:'Other',
	 sbItemQuest9:'9. In the last 36 months, have you been involved in a violation of the Integrity Practices Regulations?(Including but not limited to: soliciting or accepting improper benefits, engaging in fraudulent practices, embezzlement and bribery, misappropriation or embezzlement of company assets, damaging the company’s reputation, disclosing company secrets, collusive bidding, accepting meals or gifts from related parties, and other forms of fraudulent conduct.)',

	 'qtxnr':'Please fill in your {label}',
	 'qxznr':'Please select a {label}',


	//  '投资信息':'Investment Information',
	//  'qyxx':'Company information',
	//  'br':'I',
	//  'trmy':'In the name of others',
	//  'xm':'Name',
	//  'sjh':'Mobile phone number',
	//  'tzms':'Investment model',
	//  'zb':'Percent',
	//  'qt':'Other',
	//  'ms':'Description',
	//  'bz':'Remarks',
	//  'qtxsbsxms':'Please fill in the declaration description',
	//  'tjcg':'Added successfully',
	//  'sccg':'Deleted successfully',
	//  'gxrxx':'Related Person Information',
	//  'gx':'Relationship',

	 
	//  'br':'I',
	//  'trmy':'In the name of others',
	//  'ysyjtdgx':'Relationship with SANY Group',
	//  'tzlx':'Types of investment',
	//  'dz':'Sole proprietorship',
	//  'hzhg':'Joint venture/joint stock',
	//  'zc':'Temporary storage',
}

export default en

